<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Favoritos</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" md="3" class="mt-4 mb-2">
                <b-button variant="default" pill block size="sm" @click="clearData" v-b-modal.account>
                    <i class="material-icons mdi mdi-account-plus"></i>&nbsp;
                    <span>Agregar Favorito</span>
                </b-button>
            </b-col>
            <b-col cols="12" md="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay favoritos que coincidan con la búsqueda"
                    empty-text="No tienes favoritos registrados"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(show_details)="row">
                        <b-button variant="info" size="sm" @click="row.toggleDetails" class="mr-2">
                            <i :class="row.detailsShowing ? 'material-icons rotate180' : 'material-icons'">expand_circle_down</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>

                    <template #row-details="row">
                        <b-card class="rounded-0">
                            <b-row class="justify-content-center mx-0 my-2">
                                <b-col cols="12" md="6" class="text-center text-sm-right">
                                    <b>Nombre:</b><br>{{ row.item.cname }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left">
                                    <b>Documento:</b><br>{{ row.item.dni }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-right">
                                    <b>Email:</b><br>{{ row.item.email }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left">
                                    <b>Teléfono:</b><br>{{ row.item.mobile }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-right" v-if="row.item.bank_name">
                                    <b>Banco:</b><br>{{ row.item.bank_name }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left" v-if="row.item.nc">
                                    <b>Cuenta {{ row.item.tc === 'Ahorros' ? 'de '+row.item.tc : row.item.tc }}:</b><br>{{ row.item.nc }}
                                </b-col>
                                <b-col cols="12" class="text-center">
                                    <b>Dirección:</b><br>{{ row.item.address+' '+row.item.district+', '+row.item.city+' - '+row.item.state+', '+row.item.country_name }}
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <b-col cols="12" md="6" class="text-center text-sm-right mt-3">
                                    <b-button variant="default" class="mr-2" @click="clearData(row.item.id)" v-b-modal.account>
                                        <i class="material-icons">manage_accounts</i>&nbsp;&nbsp;Editar
                                    </b-button>
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left mt-3">
                                    <b-button variant="danger" class="mr-2" @click="trash(row.item.id)">
                                        <i class="material-icons">person_remove</i>&nbsp;&nbsp;Eliminar
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Account -->
                <b-modal
                    id="account"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(id > 0 ? 'Editar' : 'Agregar') + ' Favorito'"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formAccount" @submit.stop.prevent="id === 0 ? exec() : exec(id)">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.country+':'">
                                    <b-form-select
                                        name="country"
                                        :options="countries"
                                        :value="form.country"
                                        v-model="form.country"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('country')"
                                        :data-vv-as="(labels.country).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="country-live-feedback"/>
                                    <b-form-invalid-feedback id="country-live-feedback">{{
                                            veeErrors.first('country')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.bank+':'">
                                    <b-form-select
                                        name="bank"
                                        :options="banks"
                                        :value="form.bank"
                                        v-model="form.bank"
                                        text-field="name"
                                        value-field="code"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('bank')"
                                        :data-vv-as="(labels.bank).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="bank-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="bank-live-feedback">{{
                                            veeErrors.first('bank')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name+':'">
                                    <b-form-input
                                        name="name"
                                        v-model="form.name"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="name-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{
                                            veeErrors.first('name')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname+':'">
                                    <b-form-input
                                        name="lname"
                                        v-model="form.lname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')"
                                        :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="lname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{
                                            veeErrors.first('lname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname+':'">
                                    <b-form-input
                                        name="mname"
                                        v-model="form.mname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'alpha_spaces|max:19'"
                                        :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{
                                            veeErrors.first('mname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td+':'">
                                    <b-form-select
                                        name="td"
                                        :options="td"
                                        :value="form.td"
                                        v-model="form.td"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('td')"
                                        :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="td-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="td-live-feedback">{{
                                            veeErrors.first('td')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.nd+':'">
                                    <b-form-input
                                        name="nd"
                                        v-model="form.nd"
                                        :type="typeND ? 'text' : 'number'"
                                        :inputmode="typeND ? 'text' : 'numeric'"
                                        class="text-center"
                                        v-validate="'required:true' + validateND"
                                        :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nd-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{
                                            veeErrors.first('nd')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy+':'">
                                    <b-form-select
                                        name="sender_issuedBy"
                                        :options="countries_list"
                                        :value="form.issuedBy"
                                        v-model="form.issuedBy"
                                        v-validate="'required:true'"
                                        :state="validateState('issuedBy')"
                                        :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="issuedBy-live-feedback"
                                        class="form-control"
                                        value-field="iso2"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email+':'">
                                    <b-form-input
                                        name="email"
                                        v-model="form.email"
                                        type="email"
                                        class="text-center"
                                        v-validate="'required:true|email'"
                                        :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="email-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{
                                            veeErrors.first('email')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile+':'">
                                    <b-form-input
                                        name="mobile"
                                        v-model="form.mobile"
                                        type="tel"
                                        inputmode="tel"
                                        class="text-center"
                                        v-validate="'required:true|numeric' + vMobile"
                                        :state="validateState('mobile')"
                                        :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mobile-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{
                                            veeErrors.first('mobile')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.tc+':'">
                                    <b-form-select
                                        name="tc"
                                        :options="tc"
                                        :value="form.tc"
                                        v-model="form.tc"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('tc')"
                                        :data-vv-as="(labels.tc).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="tc-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="tc-live-feedback">{{
                                            veeErrors.first('tc')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.nc+':'">
                                    <b-form-input
                                        name="nc"
                                        v-model="form.nc"
                                        :type="typeNC ? 'text' : 'number'"
                                        :inputmode="typeNC ? 'text' : 'numeric'"
                                        class="text-center"
                                        v-validate="'required:true' + validateNC"
                                        :state="validateState('nc')"
                                        :data-vv-as="(labels.nc).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nc-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="nc-live-feedback">{{
                                            veeErrors.first('nc')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" v-if="form.country === 'AR'">
                                <b-form-group :label="labels.cbu+':'">
                                    <b-form-input
                                        name="cbu"
                                        v-model="form.cbu"
                                        type="number"
                                        inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|digits:22|cbu|is_not:' + '0'.repeat(22)"
                                        :state="validateState('cbu')"
                                        :data-vv-as="(labels.cbu).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="cbu-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="cbu-live-feedback">{{ veeErrors.first('cbu') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.country === 'BR'">
                                <b-form-group :label="labels.nab+':'">
                                    <b-form-input
                                        name="nab"
                                        v-model="form.nab"
                                        type="number"
                                        inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('nab')"
                                        :data-vv-as="(labels.nab).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nab-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="nab-live-feedback">{{ veeErrors.first('nab') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.country === 'BR'">
                                <b-form-group :label="labels.cpf+':'">
                                    <b-form-input
                                        name="cpf"
                                        v-model="form.cpf"
                                        type="number"
                                        inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|digits:11'"
                                        :state="validateState('cpf')"
                                        :data-vv-as="(labels.cpf).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="cpf-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="cpf-live-feedback">{{ veeErrors.first('cpf') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.address+':'">
                                    <b-form-input
                                        name="address"
                                        v-model="form.address"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|min:3|max:70'"
                                        :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="address-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{
                                            veeErrors.first('address')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.district+':'">
                                    <b-form-input
                                        name="district"
                                        v-model="form.district"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|min:3|max:35'"
                                        :state="validateState('district')"
                                        :data-vv-as="(labels.district).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="district-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="district-live-feedback">{{
                                            veeErrors.first('district')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city+':'">
                                    <b-form-input
                                        name="city"
                                        v-model="form.city"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('city')"
                                        :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="city-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{
                                            veeErrors.first('city')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state+':'">
                                    <b-form-input
                                        name="state"
                                        v-model="form.state"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('state')"
                                        :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="state-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{
                                            veeErrors.first('state')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formAccount" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (id > 0 ? 'Actualizando...' : 'Guardando...') : (id > 0 ? 'Actualizar' : 'Guardar') }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Favorites",
    data: () => ({
        id: 0,
        labels: {
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            issuedBy: 'País de emisión',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',

            bank: 'Entidad Bancaria',
            tc: 'Tipo de Cuenta',
            nc: 'Número de Cuenta',
            cbu: 'Número CBU/CVU',
            cpf: 'Número CPF',
            nab: 'Número de Agencia Bancaria',

            address: 'Dirección',
            district: 'Barrio/Comuna',
            city: 'Ciudad',
            state: 'Estado',
            country: 'País'
        },
        form: {
            name: null,
            lname: null,
            mname: null,
            td: null,
            nd: null,
            issuedBy: null,
            email: null,
            mobile: null,

            bank: null,
            bank_name: null,
            tc: null,
            nc: null,
            cbu: null,
            cpf: null,
            nab: null,

            address: null,
            district: null,
            city: null,
            state: null,
            country: 'PE',
            country_name: 'Perú'
        },
        countries: [
            { text: 'AR - Argentina', value: 'AR' },
            { text: 'BO - Bolivia', value: 'BO' },
            { text: 'BR - Brasil', value: 'BR' },
            { text: 'CO - Colombia', value: 'CO' },
            { text: 'DE - Alemania', value: 'DE' },
            { text: 'DO - Rep. Dominicana', value: 'DO' },
            { text: 'EC - Ecuador', value: 'EC' },
            { text: 'ES - España', value: 'ES' },
            { text: 'FR - Francia', value: 'FR' },
            { text: 'HT - Haiti', value: 'HT' },
            { text: 'IT - Italia', value: 'IT' },
            { text: 'PE - Perú', value: 'PE' },
            { text: 'US - Estados Unidos', value: 'US' },
            { text: 'VE - Venezuela', value: 'VE' }
        ],
        countries_list: [],
        banks: [],
        tc: [
            { value: 'Ahorros', text: 'Cuenta de Ahorros' },
            { value: 'Corriente', text: 'Cuenta Corriente' }
        ],
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'cname', label: 'Nombre', sortable: true },
            { key: 'dni', label: 'Documento', sortable: true },
            { key: 'account', label: 'Cuenta', sortable: true },
            { key: 'country_name', label: 'País', sortable: true },
            { key: 'show_details', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'historypage');
        this.getData();
        this.getBanks();
    },
    watch: {
        'form.country'() {
            this.form.bank = null;
            this.form.bank_name = null;
            this.getBanks();
        },
        'form.nd'() {
            if (this.typeND) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.nc'() {
            if (this.typeNC) {
                this.form.nc = (this.form.nc).toUpperCase();
            }
        }
    },
    computed: {
        td() {
            let td = [
                { value: 'DNI', text: 'Documento Nacional de Identidad' },
                { value: 'CI', text: 'Cedula de Identidad' },
                { value: 'CE', text: 'Cedula de Extranjeria' },
                { value: 'PS', text: 'Pasaporte' }
            ];
            if (this.form.country === 'AR' && this.form.payReceiver === 'Bank') {
                td = [
                    { value: 'CUIT', text: 'CUIT/CUIL' }
                ];
                this.form.td = 'CUIT';
            } else if (this.form.country === 'CO' && this.form.bank === '9999') {
                td = [
                    { value: 'NIT', text: 'Número de Identificación Tributaria' }
                ];
                this.form.td = 'NIT';
            }
            return td;
        },
        typeND() {
            return this.form.td === 'PS' || (this.form.td === 'CI' && this.form.country === 'BO') ||
                this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateND() {
            let nd = '';
            if (this.form.td !== 'PS') {
                if (this.form.country === 'AR') {
                    if (this.form.payReceiver === 'Bank') {
                        nd += '|numeric|digits:11|cuit';
                    } else {
                        nd += '|numeric|digits:8';
                    }
                } else if (this.form.country === 'CO') {
                    nd += '|numeric|min:6';
                    if (this.form.td === 'CE') {
                        nd += '|max:7';
                    } else {
                        nd += '|max:10';
                    }
                } else if (this.form.country === 'EC') {
                    nd += '|numeric|min:10|max:15';
                } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                    this.form.country === 'IT') {
                    nd += '|min:6|max:19|alpha_num|tn';
                }
            } else if (this.form.country === 'AR') {
                nd += '|min:8|max:10';
            }
            return nd;
        },
        vMobile() {
            let m = '';
            if (this.form.country === 'AR') {
                m += '|digits:11';
            } else if (this.form.country === 'CO') {
                m += '|digits:10';
            } else if (this.form.country === 'EC' || this.form.country === 'PE') {
                m += '|digits:9';
            }
            return m;
        },
        typeNC() {
            return this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateNC() {
            let nc = '|numeric';
            if (this.form.country === 'VE') {
                nc += '|digits:20';
            } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'GR' || this.form.country === 'IT') {
                nc = '|min:14|max:32|alpha_num|tn';
            } else if (this.form.country === 'CO') {
                let bank = this.form.bank !== null ? (this.form.bank).slice(4) : '';
                if (bank === 'CCAICOBB' || bank === 'PICHCOBB' || bank === 'BPOPCOBB') {
                    nc += '|min:9|max:12';
                } else if (bank === 'BAVICOBB') {
                    nc += '|min:9';
                    if (this.form.tc === 'Ahorros') {
                        nc += '|max:11';
                    } else if (this.form.tc === 'Corriente') {
                        nc += '|max:13';
                    }
                } else if (bank === 'CASOCOBB' || bank === 'FIACCOB1') {
                    nc += '|min:11|max:12';
                } else if (bank === 'COLPCOBB') {
                    nc += '|min:9|max:10';
                } else if (bank === 'CAFECOBB') {
                    nc += '|min:12|max:16';
                } else if (bank === 'OCCICOBC' || bank === 'BCTOCOBB' || bank === 'LP001292') {
                    nc += '|digits:9';
                } else if (bank === 'CITICO21' || bank === 'LP001507') {
                    nc += '|digits:10';
                } else if (bank === 'COLOCOBM') {
                    nc += '|digits:11';
                } else if (bank === 'FALACOBB') {
                    nc += '|digits:12';
                } else if (bank === 'PRCBCOBB' || (bank === 'LP001289' && this.form.tc === 'Corriente')) {
                    nc += '|digits:13';
                } else if (bank === 'FBBVCOBB') {
                    nc += '|min:9|max:20';
                } else if (bank === 'BSUDCOBB') {
                    nc += '|min:8|max:11';
                }
            } else if (this.form.country === 'BO') {
                const code = this.form.bank != null ? String(this.form.bank) : '';
                if (window.BO_JETPERU_WALLET_BANK_CODES.includes(code)) {
                    nc += '|digits:8|bo_wallet_phone';
                } else {
                    nc += '|min:5|max:20';
                }
            } else if (this.form.country === 'EC') {
                nc += '|min:6|max:34';
            }
            return nc;
        }
    },
    methods: {
        getData() {
            axios.get('/api/customer/favorites').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.favorites;
                    this.countries_list = res.data.countries;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.totalRows = this.items.length;
                this.isBusy = false;
            });
        },
        getBanks() {
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/banks').then((res) => {
                this.banks = res.data.banks;
                if (this.form.bank === null) {
                    this.form.bank = res.data.banks[0].code;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        clearData(id) {
            this.form = {
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                issuedBy: null,
                email: null,
                mobile: null,

                bank: null,
                bank_name: null,
                tc: null,
                nc: null,
                cbu: null,
                cpf: null,
                nab: null,

                address: null,
                district: null,
                city: null,
                state: null,
                country: 'PE',
                country_name: 'Perú'
            };
            if (id) {
                this.id = id;
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        let lname = (items[i].lname).split(', ', 2);
                        this.form = items[i];
                        this.form.lname = lname[0];
                        this.form.mname = lname[1] ? lname[1] : '';
                    }
                }
            } else {
                this.id = 0;
            }
        },
        exec(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = '/api/customer/favorites';
                if (id > 0) {
                    url += '/' + id + '/edit';
                } else {
                    url += '/add';
                }
                axios.post(url, this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getData();
                        this.$bvModal.hide('account');
                        this.clearData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        trash(id) {
            let account = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    account = items[i].account;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar este favorito?',
                text: 'Cuenta ' + account,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'No, cancelar',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/customer/favorites/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    }
}
</script>

<style scoped>

</style>
